<template>
  <div class="taobao-box">
     <van-nav-bar
  title="淘宝商品搜索"
  fixed
  left-arrow
  @click-left="$router.go(-1)"
/>
    <vueSearch @onSearch="onSearch"></vueSearch>
    <van-tabs v-model="active" @click="doSort" v-if="keyword!=''">
      <van-tab title="默认排序"></van-tab>
      <van-tab title="价格低"></van-tab>
      <van-tab title="价格高"></van-tab>
      <van-tab title="销量"></van-tab>
    </van-tabs>
     <good v-for="(item,index) in goodList"
       :good="item"
      :key="index">
    </good>
    <div v-show="goodList.length === 0">
      <van-empty description="暂无搜索结果" />
    </div>
    <van-button type="default" size="large" v-show="more && goodList.length>0" @click="loadMore">加载更多</van-button>
  </div>
</template>

<script>
  import good from '../../components/taobao/good'

export default {
  components:{
    good
  },
  data() {
    return {
      keyword: "",
      goodList: [],
      more: true, // 是否有分页
      page: 1,
      active: -1
    };
  },
  methods: {
    // 获取数据
    getData(data) {
      this.Post(data, "/taobao/dgMaterialOptional", res => {
        if (res.states == 1) {
          let good = res.data.result_list.map_data;
           if(good.length === 0){
            this.more = false
          }
          this.goodList = this.goodList.concat(good);
        }
      });
    },
    // 搜索
    onSearch(keyword) {
      this.goodList = [];
      this.page = 1;
      this.total_results=0;
      this.keyword = keyword;
      let data = {
        q: keyword,
        platform: this.$store.state.platform
      };
      this.getData(data);
    },
    // 查看商品详情
    showDetail(item){
      const id=item.num_iid
      window.localStorage.setItem('goodInfo',JSON.stringify(item))
      this.$router.push('/taobao/detail?id='+id);
    },
    // pc端领券购买
    goBuy(url) {
      window.open(url);
    },
    // 复制淘口令
    doCopy(item) {
      let url = "https:" + item.coupon_share_url;
      if (item.coupon_share_url == undefined) {
        url = item.coupon_click_url;
      }
      this.Post(
        {
          text: item.title,
          url: url,
          logo: item.pict_url
        },
        "/taobao/createTpwd",
        res => {
          if (res.states == 1) {
            let model = res.data.data.model;
            this.$router.push("/taobao/share?code=" + model);
          }
        }
      );
    },
    // 加载更多
    loadMore() {
      if (this.more) {
        this.page++;
        let data = {
          page: this.page,
          q: this.keyword,
          platform: this.$store.state.platform
        };
        this.getData(data);
      }
    },
    // 排序筛选
    doSort(index, title) {
      let type = "tk_rate_des";
      //排序_des（降序），排序_asc（升序） 销量（total_sales），淘客佣金比率（tk_rate）， 累计推广量（tk_total_sales），总支出佣金（tk_total_commi），价格（price
      switch (title) {
        case "默认排序":
          type = "tk_rate_des";
          break;
        case "价格低":
          type = "price_asc";
          break;
        case "价格高":
          type = "price_des";
          break;
        case "销量":
          type = "total_sales_des";
          break;
        default:
          type = "tk_rate_des";
          break;
      }
      this.page = 1;
      this.total_results=0;
      this.goodList = [];
      let data = {
        q: this.keyword,
        platform: this.$store.state.platform,
        sort: type
      };
      this.getData(data);
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.taobao-box {
  padding-top: 46px;
}
</style>



// WEBPACK FOOTER //
// src/pages/taobao/search.vue